import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a93d9b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "flex-col-centered textarea-container",
  style: {"flex":"1 1 auto","row-gap":"5px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "overrideMessage" }, "Please enter comments for overriding contract validation(s):", -1))
const _hoisted_3 = { class: "submit-btn" }

import { ref, computed } from 'vue';
import Popup from '../Popup.vue';
import { contractApprovalValidationOverride } from '@/services/network';
import { authService } from '@/auth/authSingleton';
import useSpinnerPopup from '@/services/composables/SpinnerPopup';
import {ContractValidationType} from '@/models/enums/ContractValidationType';
import useNotifierWithErrFormatter from '@/services/composables/NotifierWithErrFormatter';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContractValidationOverridePopup',
  props: {
    modelValue: {},
    validationType: {},
    setToValid: { type: Boolean }
  },
  emits: ["update:modelValue", "override"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const text = ref('');
const working = ref(false);
const validStr = computed(()=>props.setToValid ? 'VALID' : 'INVALID');
async function forceValidation(contractIDs?: string[], setToValid?: boolean) {
    if (working.value) return;
    const closeSpinner = useSpinnerPopup().show();
    try {
        working.value = true;
        if (!contractIDs) {
            throw new ReferenceError('contractIDs is unexpectedly null. (popup shouldn\'t be open)');
        }
        setToValid = !!setToValid;
        const overrideMessage = text.value;
        const username = authService.getEmailAddress();
        await contractApprovalValidationOverride.post({
            validationType: props.validationType,
        }, {
            contractIDs,
            username,
            setToValid,
            overrideMessage,
        });
        working.value = false;
        useNotifierWithErrFormatter().success({ msg: `Successfully forced contracts to be ${setToValid ? 'valid' : 'invalid'} for:\n${contractIDs}` });
        emits('override', contractIDs, setToValid);
        close();
    } catch(error) {
        useNotifierWithErrFormatter().error({ error, errorType: 'Forcing Validation Result'});
    } finally {
        closeSpinner();
        working.value = false;
    }
}
function close() {
    text.value = '';
    emits('update:modelValue');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    "model-value": !!_ctx.modelValue,
    "onUpdate:modelValue": close,
    "has-close": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (forceValidation(_ctx.modelValue,_ctx.setToValid)), ["prevent"])),
        class: "flex-col-centered",
        style: {"row-gap":"1lh"}
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _withDirectives(_createElementVNode("textarea", {
            id: "overrideMessage",
            required: "",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event))
          }, null, 512), [
            [_vModelText, text.value]
          ])
        ]),
        _createElementVNode("button", _hoisted_3, "Confirm overriding validation(s) to be " + _toDisplayString(validStr.value), 1)
      ], 32)
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})